export default class YouTubeVideo {
    constructor(play_button) {
        play_button.addEventListener('click', () => {
            let video_id = play_button.dataset.videoId;
            let iframe_video = document.createElement('iframe');

            iframe_video.loading = 'lazy';
            iframe_video.src = `https://www.youtube-nocookie.com/embed/${video_id}?autoplay=1`;
            iframe_video.className = 'video-intro__video';
            iframe_video.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe_video.allowFullscreen = true;

            play_button.parentElement.appendChild(iframe_video);
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const youTubeVideos = [...document.querySelectorAll('.js-yt-video-play')];
    if(youTubeVideos.length > 0) {
        youTubeVideos.forEach((youTubeVideo) => {
            new YouTubeVideo(youTubeVideo);
        });
    }
});
